/**
 * Origins públicos da loja (www) — só para links opcionais (produto, menu Loja).
 * Login do ERP é nativo neste app; não há redirect para a loja.
 *
 * REACT_APP_STOREFRONT_URL — loja Next
 *   - prod: https://www.promedicopel.com.br
 *   - local: http://localhost:3001
 */

const DEFAULT_STOREFRONT_ORIGIN = 'https://www.promedicopel.com.br';
const LOCAL_STOREFRONT_ORIGIN = 'http://localhost:3001';
const ERP_DASHBOARD_PATH = '/erp/dashboard';

function stripTrailingSlash(url) {
  return String(url || '').trim().replace(/\/$/, '');
}

function isLocalErpHost() {
  if (typeof window === 'undefined' || !window.location?.hostname) return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

export function getStorefrontOrigin() {
  const fromEnv = stripTrailingSlash(process.env.REACT_APP_STOREFRONT_URL || '');
  if (fromEnv) return fromEnv;
  if (process.env.NODE_ENV === 'development' && isLocalErpHost()) {
    return LOCAL_STOREFRONT_ORIGIN;
  }
  return DEFAULT_STOREFRONT_ORIGIN;
}

/** Path do dashboard ERP neste host. */
export function getErpDashboardPath() {
  return ERP_DASHBOARD_PATH;
}

/**
 * URL absoluta na loja Next (atalhos "Loja" / "Compras" no UserMenu).
 * @param {string} [pathname]
 * @param {string} [search]
 * @param {string} [hash]
 */
export function getStorefrontUrl(pathname = '/', search = '', hash = '') {
  let path = String(pathname || '/').split('?')[0] || '/';
  if (!path.startsWith('/')) path = `/${path}`;
  // Next ainda não tem /orders — Compras aponta ao carrinho
  if (path === '/orders') path = '/cart';
  const base = `${getStorefrontOrigin()}${path}`;
  const qs = search && search.startsWith('?') ? search : search ? `?${search}` : '';
  const fragment = hash && hash.startsWith('#') ? hash : hash ? `#${hash}` : '';
  return `${base}${qs}${fragment}`;
}

export { ERP_DASHBOARD_PATH, DEFAULT_STOREFRONT_ORIGIN, LOCAL_STOREFRONT_ORIGIN };
